import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {TransactionService} from '../../shared/services/transaction.service';
import { AdminService } from 'src/app/shared/services/admin.service';
import Chart from 'chart.js';
import {GraphService} from '../../shared/services/graph.service';

@Component({
  selector: 'app-pie',
  standalone: true,
  templateUrl: './pie.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./pie.component.css']
})
export class PieComponent implements OnInit {
data;
  constructor(private transactionService: TransactionService, private graphService: GraphService, private adminService: AdminService) { }
  

  lineChart;
  Label: any[];
  Paid: number[];
  Failed: number[];
  Added: number[];
  myDoughnutChart;
  txt;
  details;
  ngOnInit() {

     this.adminService.getDetails().subscribe(
      data => {
        this.details = data[0];
         this.transactionService.statistics(this.details.permission, this.details.agent.id).subscribe(
      data => {
        this.data = data;
        const canvas: any =  document.getElementById('myDoughnutChartCanvas');
        const ctx: CanvasRenderingContext2D = canvas.getContext('2d');

        const dataset = {
          datasets: [
            {
            data: [this.data.new_count, this.data.successful_count, this.data.failed_count, this.data.processing_count],
            backgroundColor: [
              '#44586E',
              '#2F9E44',
              '#D92D20',
              '#B7791F'
            ],
            hoverBackgroundColor: [
              '#31414F',
              '#26823A',
              '#B42318',
              '#96650F'
            ],
          }],
          labels: [
            'New',
            'Successful',
            'Failed',
            'Processing'
          ],
        };
        this.myDoughnutChart = new Chart(ctx, {
          type: 'doughnut',
          data: dataset
        });
      }
    );
      });
   
  }


}
